module.exports = __webpack_public_path__ + "img/border_polygon.e045a351.svg";